import Modal from 'react-bootstrap/Modal';

const AccessDeniedMessageModal = ({ showModal, handleHideModal, message }) => {

    return (
        <Modal
            backdrop="static"
            show={showModal}
            onHide={handleHideModal}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Law Firm Access Denied</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="form-field-wrapper">
                    {message}
                </div>
            </Modal.Body>

            <Modal.Footer></Modal.Footer>
        </Modal>
    );
};

export default AccessDeniedMessageModal;